var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "CheckboxGroup",
        {
          class: { checkbox_disable: _vm.disabled },
          style: { "max-width": _vm.maxWidth },
          on: { "on-change": _vm.changeDataList },
          model: {
            value: _vm.tempDataList,
            callback: function ($$v) {
              _vm.tempDataList = $$v
            },
            expression: "tempDataList",
          },
        },
        [
          _vm._l(_vm.enumList, function (item) {
            return _c(
              "Checkbox",
              {
                style: { display: _vm.display, "font-size": _vm.fontSize },
                attrs: { label: item.code, disabled: item.disabled },
              },
              [_c("span", [_vm._v(_vm._s(item.value))])]
            )
          }),
          _vm._t("default"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }